exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-container[data-v-1b9c3df5] {\n  margin-bottom: 20px;\n}\n.table-container[data-v-1b9c3df5] {\n  padding-bottom: 40px;\n}\n.table-container .pagination-container[data-v-1b9c3df5] {\n    margin-top: 16px;\n    text-align: right;\n}\n", ""]);

// exports
